import { Row, Tabs } from "antd";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Notify from "../../components/common/Notify";
import {
  groupNotificationSelector,
  pupSelector,
} from "../../services/selector/index.";
import {
  resetState,
  resetStatus,
} from "../../services/slice/GroupNotificationSlice";
import { setOpenPUDelete } from "../../services/slice/PopUpSlice";
import "../../assets/style/pageStyle/postDeals.scss";
import ModalDelete from "../../components/common/Modal/delete/ModalDelete";
import ModalGetLog from "../../components/common/Modal/getLog/ModalGetLog";
import TableGroupNotifycation from "../../components/common/Table/TableGroupNotifycation";
import ModalAddGroupNotification from "../../components/common/Modal/add/ModalAddGroupNotification";
import ModalDetailGroupNotification from "../../components/common/Modal/getDetail/ModalDetailGroupNotification";
import ModalEditGroupNotification from "../../components/common/Modal/edit/ModalEditGroupNotification";
import {
  deleteGroupNotify,
  setOpenModalGetLogGroupNotification,
} from "../../services/slice/GroupNotificationSlice";

const GroupNotifycation = () => {
  const dispatch = useDispatch();
  const groupNotifyState = useSelector(groupNotificationSelector);
  const groupNotificationState = useSelector(groupNotificationSelector);
  const pupState = useSelector(pupSelector);
  const { dataDelete } = pupState;
  const { t } = useTranslation();

  useEffect(() => {
    return () => dispatch(resetState());
  }, [dispatch]);
  const dataSource = useMemo(() => {
    const result = groupNotificationState?.dataLog.map((item, index) => {
      return {
        ...item,
        timeUpdate: item.actionAt,
        content: item.description,
        userChange: item.actionBy,
      };
    });
    return result;
  }, [groupNotificationState?.dataLog]);

  const handleDelete = () => {
    dispatch(deleteGroupNotify(dataDelete.id));
    dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
  };
  return (
    <div className="wrapperPostDeals containerContentPage">
      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          handleDelete={handleDelete}
          width={600}
          content="Bạn có đồng ý xóa thông báo nhóm không?"
        />
      )}
      <Notify
        content={groupNotifyState.msg}
        isNotify={groupNotifyState.isNotify}
        title="Thông báo"
        type={groupNotifyState.typeNotify}
        reset={resetStatus}
      />
      {groupNotificationState.isOpenModalGetLog && (
        <ModalGetLog
          open={groupNotificationState.isOpenModalGetLog}
          setOpen={setOpenModalGetLogGroupNotification}
          data={dataSource}
        />
      )}
      {groupNotificationState.isOpenModalPostGroupNotification && (
        <ModalAddGroupNotification title={"Thêm mới thông báo"} />
      )}
      {groupNotificationState.isOpenModalEditGroupNotification && (
        <ModalEditGroupNotification title={"Chỉnh sửa thông báo"} />
      )}
      {groupNotificationState.isOpenModalDetail && (
        <ModalDetailGroupNotification title={"Xem chi tiết"} />
      )}
      <div className="headerPage">
        <h2 className="title">{t("Thông báo nhóm với Bkav Pro")}</h2>
      </div>
      <Row className="tableContent">
        <TableGroupNotifycation />
      </Row>
    </div>
  );
};

export default GroupNotifycation;
